'use strict';

module.exports = {
    devMode: false,
    setDebug: function setDebug() {
        this.devMode = true;
    },
    ignore: function ignore() {
        if (window.Owl && window.Owl.debugLog) {
            window.console.log('【OWL日志:】');
            window.console.log && window.console.log.apply(window.console, arguments);
        }
    },
    log: function log(msg) {
        this.devMode && console.log('[Owl]', msg);
    },
    warn: function warn(msg) {
        this.devMode && console.warn('[Owl]', msg);
    },
    logScreen: function logScreen() {
        if (window.Owl && window.Owl.cfgManager.get('page').logFirstScreen) {
            console.log.apply(console, arguments);
        }
    }
};